import store from '@/store';
import { message, notification } from 'ant-design-vue';

/* eslint-disable */

export const isArray = (e) => toString.apply(e) === '[object Array]';

export const isObject = (e) => toString.apply(e) === '[object Object]';

export const isString = (e) => toString.apply(e) === '[object String]';

export const isUndefined = (e) => e == null;

export const isBoolean = (e) => toString.apply(e) === '[object Boolean]';

export const isNumber = (val) => Object.prototype.toString.call(val) === '[object Number]';

export const isEmptyObject = (e) => Object.keys(e).length === 0;
// 中间的提示
export function Toast(type: string, str: string, duration: number) {
  message[type](str, duration);
}

export function setData(sourceData: object, target: object, isEmpty: boolean) {
  Object.keys(sourceData).forEach((key) => {
    if (isEmpty) {
      target[key] = '';
    } else {
      target[key] = sourceData[key];
    }
  });
}

// 右边的提示
export function notice(type: string, title: string, description: string, duration: number) {
  notification[type]({
    message: title,
    description,
    duration,
  });
}

// 时间转化
export function addZero(num: number) {
  const newnum = num > 9 ? num : '0' + num;
  return newnum;
}

export function timeStampToTime(timeStamp: string, type: string) {
  let time;
  let str;
  if (timeStamp != '') {
    time = new Date(timeStamp);
  } else {
    time = new Date();
  }
  const year = time.getFullYear();
  let month = time.getMonth() + 1;
  let day = time.getDate();
  let hour = time.getHours();
  let minutes = time.getMinutes();
  let seconds = time.getSeconds();
  month = addZero(month);
  day = addZero(day);
  hour = addZero(hour);
  minutes = addZero(minutes);
  seconds = addZero(seconds);
  switch (type) {
    case 'day':
      str = `${year}年${month}月${day}日`;
      break;
    case 'minutes':
      str = `${year}年${month}月${day}日 ${hour}时${minutes}分`;
      break;
    case 'seconds':
      str = `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
      break;
    case 'upload':
      str = `${year}-${month}-${day}`;
      break;
    case 'print':
      str = `${year}/${month}/${day}`;
      break;
    case 'printColumba':
      str = `${year}-${month}-${day} ${hour}:${minutes}`;
      break;
    default:
      str = `${year}年${month}月${day}日 ${hour}时${minutes}分`;
      break;
  }
  return str;
}

// 下载文件
export function downloadFile(obj, name, suffix) {
  const url = window.URL.createObjectURL(new Blob([obj]));
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  const fileName = timeStampToTime('', 'day') + '-' + name + '.' + suffix;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function checkSeparate(params: string) {
  const lastStr = params.charAt(params.length - 1);
  return lastStr === '?' || lastStr === '&';
}

// 转换下请求的数据
export function payloadToQuery(obj, originurl: string, useList: boolean) {
  console.log(obj);
  let url = originurl;
  url = url.indexOf('?') === -1 ? `${url}?` : url;
  const requestBoby = {
    data: []
  };
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    if (key === 'query' && value.arr.length === 1 && !useList) {
      value.arr.forEach((subitem) => {
        url = `${url}${value.name}=${subitem}`;
      });
    } else if (key === 'query' && useList) {
      value.arr.forEach((subitem) => {
        requestBoby.data.push(subitem);
      });
    } else if (key === 'query' && value.arr.length > 1 && !useList) {
      value.arr.forEach((subitem) => {
        url += checkSeparate(url) ? `${value.name}=${subitem}` : `&${value.name}=${subitem}`;
      });
    } else {
      url += checkSeparate(url) ? `${key}=${value}` : `&${key}=${value}`;
    }
  });
  console.log([url, requestBoby]);
  return [url, requestBoby];
}

export const showUploading = (msg) => {
  store.commit("SET_LOADING_STATUS", {
    status: true,
    msg,
  });
};

export const hideUploading = () => {
  store.commit("SET_LOADING_STATUS", {
    status: false,
    msg: '',
  });
};

export const uploadMedia = (uImgRef, uVideoRef) => {
  showUploading('上传中');
  return new Promise((resolve, reject) => {
    const uploadImgP = uImgRef.uploadFile === undefined ? uImgRef.value.uploadFile() : uImgRef.uploadFile();
    const uploadVideoP = uVideoRef.uploadFile === undefined ? uVideoRef.value.uploadFile() : uVideoRef.uploadFile();
    const uploadFile = Promise.all([uploadImgP, uploadVideoP]);
    uploadFile
      .then((res) => {
        resolve(res);
        hideUploading();
      })
      .catch((err) => {
        reject(err);
        hideUploading();
      });
  });
};

export const debounce = (fun, delay = 500) => {
  let timer;
  return function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      fun.call(this, ...arguments);
    }, delay);
  };
};

export const validateForm = (checkObj, validate) => {
  Object.keys(validate).forEach((key) => {
    if (checkObj[key] === null || checkObj[key] === "") {
      Toast("warning", validate[key].error, 3);
      throw new Error("no filed");
    }
  });
};

export const validateInspector = (str) => {
  if (!str || str.indexOf('inspectionPersonnel') === -1) {
    Toast("warning", '请增加次数填写送检人', 3);
    hideUploading()
    throw new Error("no Inspector");
  }
  if (!str || str.indexOf('qualityPersonnel') === -1) {
    Toast("warning", '请增加次数填写质检人', 3);
    hideUploading()
    throw new Error("no Inspector");
  }
};

export const isValidDate = (dateString) => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateString.match(regex)) {
    return false; // 格式不正确  
  }

  const parts = dateString.split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  // 检查月份是否在1到12之间  
  if (month < 1 || month > 12) {
    return false;
  }

  // 创建一个数组来存储每个月的天数，考虑到闰年  
  const daysInMonth = new Array(31, (28 as any) + ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);

  // 检查日期是否在有效范围内  
  if (day < 1 || day > daysInMonth[month - 1]) {
    return false;
  }

  // 最后，使用Date对象验证日期是否有效（这一步可以省略，因为前面的检查已经足够严格）  
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day;
}

export const isComputer = () => {
  const userAgent = navigator.userAgent;
  return /Windows|Macintosh|Android Tablet/.test(userAgent);
};

